import React, { useState } from 'react'

import { BASE_URL } from '../api/index';
import { Typography, List, ListItem, Accordion, Box, AccordionSummary, AccordionDetails, CardContent, CardActions, CardMedia, CardHeader, Button, Alert } from '@mui/material';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { green, red, grey } from '@mui/material/colors';

export default function Answer({ qnAnswers }) {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded?panel:false)
    };

    const markCorrectOrNot = (qna, idx) => {
        if ([qna.answer,qna.selected].includes(idx)) {
            return { sx: {color:qna.answer===idx?green[500]:red[500]}}
        }
    }

    return (
        <Box sx={{ mt: 1, mb:1, width: '100%', maxWidth: 640, mx: 'auto' }}>
            <Typography variant="h2">
            Questions and Answers
            </Typography>
            {
                qnAnswers.map((item, j) => (
                    <Accordion
                        disableGutters
                        key={j}
                        expanded={expanded===j}
                        onChange={handleChange(j)}
                    >
                        <AccordionSummary expandIcon={<ExpandCircleDownIcon
                            sx={{color:item.answer===item.selected ? green[500]:red[500]} }
                        />}>
                            <Typography sx={{ width: '90%', flexShrink: 0 }}>
                                {item.qnInWords}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: grey[400] }}>
                            {item.imageName !== null
                            ? <CardMedia
                                component="img"
                                image={BASE_URL + 'Images/' + item.imageName}
                                sx={{ width: 'auto', m: '10px auto' }} />
                                : null}
                            <List>
                                {
                                    item.options.map((x, i) =>
                                        <ListItem key={i}>
                                            <Typography {...markCorrectOrNot(item,i) }>
                                                <b>
                                                    {String.fromCharCode(65 + i) + " . "}{x}
                                                </b>
                                            </Typography>
                                        </ListItem>
                                    )
                                }
                            </List>
                        </AccordionDetails>

                </Accordion>))
            }
        </Box>
    )
}